
export const DEFAULT_LIST_LIMIT = 50;
export const MAX_LIST_LIMIT = 500;

export function refetchLimit(
  params: { limit?: number } | undefined,
  loaded: number,
): number | undefined {
  const base = params?.limit ?? DEFAULT_LIST_LIMIT;
  if (loaded <= base) return undefined;
  return Math.min(loaded, MAX_LIST_LIMIT);
}

export function mergeRefetched<T extends { id: string }>(
  prev: T[],
  fresh: T[],
  requestedLimit: number,
): T[] {
  if (fresh.length < requestedLimit || prev.length <= fresh.length) return fresh;
  const seen = new Set(fresh.map((t) => t.id));
  return [...fresh, ...prev.slice(fresh.length).filter((t) => !seen.has(t.id))];
}
